import React from 'react';
import Button from '../Button/Button';

const TakeQuiz = ({ title }) => {
  return (
    <div className='quiz-wrapper'>
      <p className='quiz-wrapper__title'>{title}</p>
      <p>10 questions</p>
      <div className='quiz-wrapper__btn'>
        <button> Start Quiz</button>
      </div>
    </div>
  );
};

export default TakeQuiz;
